import { useRouter } from "./router/Router";
import { HelpLayout } from "./components/HelpLayout";
import { GuideDocument } from "./components/GuideDocument";
import { HomePage } from "./pages/HomePage";
import { CategoryPage } from "./pages/CategoryPage";
import { SearchPage } from "./pages/SearchPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { CATEGORIES, guideByRoute } from "./content/registry";
import type { CategoryId } from "./content/types";

const CATEGORY_IDS = new Set(CATEGORIES.map((c) => c.id));

function resolve(path: string) {
  if (path === "/" || path === "") return <HomePage />;
  if (path === "/search") return <SearchPage />;

  // A bare category route, e.g. /screens
  const bare = path.replace(/^\//, "");
  if (CATEGORY_IDS.has(bare as CategoryId)) {
    return <CategoryPage id={bare as CategoryId} />;
  }

  // A guide route, e.g. /screens/pair-a-screen
  const guide = guideByRoute(path);
  if (guide) return <GuideDocument guide={guide} />;

  return <NotFoundPage />;
}

export default function App() {
  const { path } = useRouter();
  return <HelpLayout>{resolve(path)}</HelpLayout>;
}
